import { useLocation } from 'react-router-dom';
import { Services } from 'services';
import { useExternalOAuthCallback } from 'services/auth/use-external-oauth-callback';

export const IdMeCallback = (): null => {
  const { search } = useLocation();
  const { idMeLogin } = Services.Auth.useIdMeLogin();

  useExternalOAuthCallback(search, idMeLogin);

  return null;
};
